(function (window) {
  /**
   * The BatchGeoStoreLocatorListItem component generates a single list item
   * that can be rendered into a list. It manages it's own independent model
   * data and creates instances of subviews for labels and thumbnails.
   *
   * It offers a handful of methods for getting specific pieces of data from
   * a list item such as it's data model (#getModel), the distance a user is
   * from it (#getDistance), as well as the content to display (#getContent)
   *
   * @example
   * // Create a stack of list items that you can do stuff with
   * this.listItems = locationData.map(function (marker, markerIndex) {
   *     marker.index = markerIndex;
   *     return new BatchGeoStoreLocatorListItem(marker)
   * });
   *
   * // Render all in your stack into some element
   * $('someElement').html(this.listItems.map(function (listItem) {
   *     return listItem.render();
   * })];
   *
   * @param {Object} markerData The data for the list item
   * @param {Number} markerData.index The index (or ID) of the list item
   * @param {string} markerData.title The title to display for list item
   * @param {string} markerData.address Address to display for the list item
   * @param {string} markerData.thumbnail A URL to an image to display in the list item
   * @param {Number} markerData.lat The latitude of the list item's location
   * @param {Number} markerData.lon The longitude of the list item's location
   *
   * @return {BatchGeoStoreLocatorListItem}
   *
   * @constructor
   */
  var BatchGeoStoreLocatorListItem = function (markerData) {
    this.setModel({
      id: markerData.id,
      index: markerData.index,
      title: markerData.t,
      address: markerData.addr,
      thumbnail: markerData.i,
      lat: markerData.lt,
      lon: markerData.ln,
      invalid:
        markerData.accuracy === "unknown" ||
        !BatchGeo.goodLatLon(markerData.lt, markerData.ln),
      phone: markerData.phone,
    });

    this.markerLabel = new window.BatchGeoStoreLocatorMarkerLabel(this);
    this.markerThumbnail = new window.BatchGeoStoreLocatorMarkerThumbnail(this);

    return this;
  };

  /**
   * Renders an `<li>` jQuery element. It takes no params and is built from
   * the data model.
   *
   * @return {jQuery}
   */
  BatchGeoStoreLocatorListItem.prototype.render = function () {
    var model = this.getModel();
    return $("<li />", {
      class:
        "storeLocator-list-item" +
        (model.invalid ? " invalid-marker-association" : ""),
      "data-marker-id": model.id,
      html: window.per.use_descIMG
        ? [
            this.markerLabel.render(),
            this.getContent(model.title, model.address),
            this.markerThumbnail.render(),
          ]
        : [
            this.markerLabel.render(),
            this.getContent(model.title, model.address),
          ],
    });
  };

  /**
   * A getter for the data model of the list item.
   * @return {{thumbnail: string, address: string, index: number, userLocation: {lastUpdated: number, hasPanned: boolean, latitude: number|null, active: boolean, accuracy: number|null, cycle: number, longitude: number|null}, lon: number, title: string, lat: number}}
   */
  BatchGeoStoreLocatorListItem.prototype.getModel = function () {
    return this.model;
  };

  /**
   * A setter for the data model of the list item. It automatically adds the
   * user location data no matter what you pass.
   *
   * @param {Object} markerData The data for the list item
   * @param {Number} markerData.index The index (or ID) of the list item
   * @param {string} markerData.title The title to display for list item
   * @param {string} markerData.address Address to display for the list item
   * @param {string} markerData.thumbnail A URL to an image to display in the list item
   * @param {Number} markerData.lat The latitude of the list item's location
   * @param {Number} markerData.lon The longitude of the list item's location
   *
   * @return {{thumbnail: string, address: string, index: number, userLocation: {lastUpdated: number, hasPanned: boolean, latitude: number|null, active: boolean, accuracy: number|null, cycle: number, longitude: number|null}, lon: number, title: string, lat: number}}
   */
  BatchGeoStoreLocatorListItem.prototype.setModel = function (markerData) {
    var userLocation = BatchGeoStore.getState().UserLocation;
    return (this.model = _.merge(markerData, { userLocation: userLocation }));
  };

  /**
   * Returns a jQuery <div> element with the title, address, and distance text
   * (if the distance exists). It takes no params since it gets all data from
   * the data model.
   *
   * @return {jQuery}
   */
  BatchGeoStoreLocatorListItem.prototype.getContent = function () {
    var model = this.getModel();
    var searchLocation = BatchGeoStore.getState().StoreLocator.searchLocation;
    var distance;

    var distanceScale = "mile";

    if (window.per.dist_sel === 1) {
      distanceScale = "kilometer";
    }

    //if the list item has no address then set milesAway to null
    if (!model.lat && !model.lon) {
      distance = null;
    } else if (searchLocation) {
      distance = BatchGeo.addCommas(
        this.getDistanceFromSearchAddress(
          model.lat,
          model.lon,
          searchLocation.lat,
          searchLocation.lon,
        ).toFixed(2),
      );
    } else {
      distance = this.getDistance();
    }

    return $("<div />", {
      class: "storeLocator-marker-content",
      html: [
        $("<h5 />", {
          class: "storeLocator-marker-title",
          html: model.title,
        }),
        $(`<a />`, {
          toggle: model.phone !== null,
          href: `tel:${model.phone}`,
          class: "storeLocator-marker-phone",
          html: model.phone,
        }),
        $("<address />", {
          class: "storeLocator-marker-address",
          html:
            model.address +
            (model.address && model.invalid
              ? " <div><strong>(no marker)</strong></div>"
              : ""),
        }),
        $("<p />", {
          // If miles away is returned as null hide this element
          toggle: distance !== null,
          class: "storeLocator-marker-distance",
          html: BatchGeo.pluralize(distance, distanceScale) + " away",
        }),
      ],
    });
  };

  /**
   * The getDistance method returns null if there is not a user lat and long
   * but if there is it will return the distance from this list item's
   * location to the user in a string (because it adds decimals and floats are
   * bad to pass for views).
   *
   * @example
   * // With user location data
   * this.getDistance()
   * // => 12.34
   *
   * // With NO user location data or just lat or just longs
   * this.getDistance()
   * // => null
   * @return {string|null}
   */

  //returns numeric distance without formatting used for sorting
  BatchGeoStoreLocatorListItem.prototype.getNumericDistance = function () {
    var model = this.getModel();
    return !model.userLocation.latitude || !model.userLocation.longitude
      ? null
      : BatchGeo.distance(
          model.lat,
          model.lon,
          model.userLocation.latitude,
          model.userLocation.longitude,
        );
  };

  //returns formatted distance
  BatchGeoStoreLocatorListItem.prototype.getDistance = function () {
    var distance = this.getNumericDistance();
    return distance ? BatchGeo.addCommas(distance.toFixed(2)) : null;
  };

  //returns distance from search
  BatchGeoStoreLocatorListItem.prototype.getDistanceFromSearchAddress =
    function (lat, lon, searchLat, searchLon) {
      var distance = BatchGeo.distance(
        lat,
        lon,
        parseFloat(searchLat),
        parseFloat(searchLon),
      );
      return distance ? distance : null;
    };

  window.BatchGeoStoreLocatorListItem = BatchGeoStoreLocatorListItem;
})(window);
